import React, { useState } from 'react'
import { calcInstance } from '../redux/axios.config'
import { Navigate, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import Cookies from 'universal-cookie'
import { routes } from './routes'
import ObserverLoginLarge from 'assets/icons/ObserverLoginLarge.png'
import LB_logo_large from 'assets/icons/LB_LOGO_Large.png'

const cookies = new Cookies()
export const Login: React.FC = () => {
  const navigate = useNavigate()
  const [name, setName] = useState(localStorage.getItem('login_name') || '')
  const [inputValue, setInputValue] = useState('')
  const [isPassWrong, setIsPassWrong] = useState(false)
  const defaultPasswordPlaceholder = "Password"
  const [passwordPlaceholder, setPasswordPlaceholder] = useState(defaultPasswordPlaceholder)
  const defaultUsernamePlaceholder = "User name"
  const [usernamePlaceholder, setUsernamePlaceholder] = useState(defaultUsernamePlaceholder)

  const checkPassword = async (username: string, pass: string) => {
    try {
      const res = await calcInstance.post('/auth/login', { userName: username, password: pass })
      if (res?.data?.success && res?.data?.token) {
        localStorage.setItem('login_name', username)
        cookies.set('TOKEN', res.data.token)
        navigate(routes.Actions)
      } else {
        setIsPassWrong(true)
        navigate('/login')
      }
    } catch (err) {
      setIsPassWrong(true)
      navigate('/login')
    }
  }
  return (
      <PasswordWindow>
        <ImgContainer/>
        <InputBlock>
          <LogoImgContainer />
          <CustomInput
            value={name}
            onChange={e => {
              setName(e.target.value)
            }}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                checkPassword(name, inputValue).then()
              }
            }}
            type="text"
            onFocus={() => setUsernamePlaceholder('')}
            onBlur={() => setUsernamePlaceholder(defaultUsernamePlaceholder)}
            placeholder={usernamePlaceholder}
          />

          <CustomInput
            style={{ marginTop: '14px' }}
            value={inputValue}
            onChange={e => {
              setIsPassWrong(false)
              setInputValue(e.target.value)
            }}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                checkPassword(name, inputValue).then()
              }
            }}
            onFocus={() => setPasswordPlaceholder('')}
            onBlur={() => setPasswordPlaceholder(defaultPasswordPlaceholder)}
            type="password"
            placeholder={passwordPlaceholder}
          />
          <LoginButton onClick={() => {
            checkPassword(name, inputValue).then()
          }}>Login</LoginButton>
          <ErrorMsg
            isVisible={isPassWrong}
          >Wrong password</ErrorMsg>
        </InputBlock>

      </PasswordWindow>
  )
}

const ErrorMsg = styled.div<{ isVisible?: boolean }>`
    font-size: 12px;
  padding: 20px 5px 0 15px;
  color: ${({ theme }) => theme.red};
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
`

const PasswordWindow = styled.div`
  width: 100vw;
  height: 100vh;
  background: ${({theme}) => theme.obs_background};
  display: flex;
  align-items: center;
    overflow: hidden;
`

const CustomInput = styled.input.attrs({
  spellCheck: false,
  autoCorrect: "off",
  autoCapitalize: "off",
})`
  background:  ${({theme}) => theme.obs_background};
  border: 1px solid ${({theme}) => theme.obs_font};
  box-shadow: inset 1px 1px 1px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 4px 10px;
  color: ${({theme}) => theme.obs_font};
  font-weight: 500;
  font-size: 13px;
    height: 38px;
    width: 260px;
    margin-top: 50px;
    &::placeholder{
        color: ${({theme}) => theme.obs_font};
    }
`

const InputBlock = styled.div`
    width: 40%;
    height: 100%;
    display: flex;
    position: relative;
    flex-direction: column;
    padding-top: 10%;
    align-items: center;
  
    background: ${({theme}) => theme.obs_block_background};
  animation: displaying 0.5s;
  @keyframes displaying {
    0% {
      opacity: 0;
      margin-bottom: -100px;
    }
    100% {
      opacity: 1;
      margin-top: 0;
    }
  }
`
const LoginButton = styled.button`
  background: ${({theme}) => theme.obs_blue};
    border: 1px solid ${({theme}) => theme.obs_blue};
    margin-top: 60px;
    border-radius: 6px;
    padding: 4px 10px;
    color: ${({theme}) => theme.obs_background};
    height: 38px;
    width: 260px;
    font-weight: 600;
    &:hover{
        background: ${({theme}) => theme.obs_background};
        border: 1px solid ${({theme}) => theme.obs_blue};
        color: ${({theme}) => theme.obs_blue}; 
    }
`
const ImgContainer = styled.div`
    background: url('${ObserverLoginLarge}') no-repeat center;
    background-size: contain;
    width: 60%;
    height: 100%;
`
const LogoImgContainer = styled.div`
    background: url('${LB_logo_large}') no-repeat center;
    background-size: contain;
    width: 130px;
    height: 90px;
`
